/**
 * Imperative turn-start overlay host — renders outside BattleUI's React tree so
 * game-update re-renders during the popup do not reconcile the overlay or restart animations.
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import TurnStartOverlay from '../components/TurnStartOverlay';

let hostEl = null;
let root = null;
let visible = false;

function ensureRoot() {
  if (root) return root;
  if (typeof document === 'undefined' || !document.body) {
    throw new Error('turnStartOverlayHost: document.body is not available');
  }
  hostEl = document.createElement('div');
  hostEl.id = 'coda-turn-start-overlay-host';
  hostEl.setAttribute('aria-hidden', 'true');
  document.body.appendChild(hostEl);
  root = createRoot(hostEl);
  return root;
}

export function isTurnStartOverlayVisible() {
  return visible;
}

export function showTurnStartOverlay(snapshot) {
  if (!snapshot) {
    throw new Error('showTurnStartOverlay: snapshot is required');
  }
  visible = true;
  ensureRoot().render(
    <TurnStartOverlay snapshot={snapshot} onComplete={hideTurnStartOverlay} />
  );
}

export function hideTurnStartOverlay() {
  visible = false;
  if (root) {
    root.render(null);
  }
}

export function destroyTurnStartOverlayHost() {
  hideTurnStartOverlay();
  if (root) {
    root.unmount();
    root = null;
  }
  if (hostEl && hostEl.parentNode) {
    hostEl.parentNode.removeChild(hostEl);
  }
  hostEl = null;
  visible = false;
}
